// extracted by mini-css-extract-plugin
export default {"imageWrapper":"lM-z","twoColumnImage":"mM-z"};